import { BROWSER_ENUM } from "./interfaces";

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export function numberWithCommas(x: string | number) {
  return Number(x).toLocaleString();
}

const testUserAgent = (regexp: RegExp): boolean => regexp.test(window?.navigator?.userAgent);

export function isBrave() {
  // @ts-ignore
  if (window.navigator?.brave?.isBrave?.name == "isBrave") {
    return true;
  } else {
    return false;
  }
}

export function detectBrowser(): BROWSER_ENUM {
  switch (true) {
    case isBrave():
      return BROWSER_ENUM.BRAVE;
    case testUserAgent(/edg/i):
      return BROWSER_ENUM.EDGE;
    case testUserAgent(/trident/i):
      return BROWSER_ENUM.INTERNET_EXPLORER;
    case testUserAgent(/firefox|fxios/i):
      return BROWSER_ENUM.FIRE_FOX;
    case testUserAgent(/opr\//i):
      return BROWSER_ENUM.OPERA;
    case testUserAgent(/ucbrowser/i):
      return BROWSER_ENUM.UC_BROWSER;
    case testUserAgent(/samsungbrowser/i):
      return BROWSER_ENUM.SAMSUNG_BROWSER;
    case testUserAgent(/chrome|chromium|crios/i):
      return BROWSER_ENUM.CHROME;
    case testUserAgent(/safari/i):
      return BROWSER_ENUM.SAFARI;
    default:
      return BROWSER_ENUM.UNKNOWN;
  }
}

export const BROWSER: BROWSER_ENUM = detectBrowser();

/**
= * @description Logger
 * @param val string/object/array
 * @param error boolean
 * @param avoid_env boolean i.e. setting `true`, will not consider environment specific log
 */
export const log = (val: any, error: boolean = false, avoid_env: boolean = false) => {
  if (process.env.NODE_ENV === "development" || avoid_env) {
    if (!error) console.log(`log: `, val);
    else console.error(`error: `, val);
  }
};

/**
 *
 * @param appName
 * @param key required [reducer's name]
 * @returns
 */
export const getReduxKey = (appName: string, key: string) => {
  let uKey = `${appName}_${process.env.REACT_APP_NODE_ENV}_${key}`;
  return uKey;
};
